module.exports = __webpack_public_path__ + "static/media/animation-e3-icon.111460bb.png";